<template>
  <DrawerContainer
    ref="drawerContainer"
    :dialogShow="dialogShow"
    v-if="dialogShow"
    :dialog-width="'40%'"
    :title="dialogTitle"
    @resetPopupData="resetDrawer"
    @submitPopupData="submitForm"
  >
    <div class="driver-box custom-form">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>司机信息
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="司机姓名" prop="username">
              <el-input
                v-model="form.username"
                clearable
                autocomplete="off"
                maxlength="30"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input
                v-model="form.phone"
                clearable
                autocomplete="off"
                maxlength="11"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属机构" prop="companyId">
              <el-select
                style="width: 100%"
                v-model="form.companyId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="常驻地址" prop="addressDot">
              <el-cascader
                key="el3"
                style="width: 100%"
                :options="options"
                ref="cascaderEnd"
                @change="handleChangeAddress"
                v-model="form.addressDot"
                :props="cityProps"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="运输线路" prop="lineType">
              <el-radio-group v-model="form.lineType">
                <el-radio :label="1">固定线路</el-radio>
                <el-radio :label="2">漫游线路</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.lineType === 1">
<!--          <el-col :span="12">-->
            <el-form-item label="运输线路" prop="lineId">
              <el-select
                style="width: 100%"
                v-model="form.lineId"
                filterable
                allow-create
                default-first-option
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in lineData"
                  :key="item.lineId"
                  :label="`${item.startCityName}
                  -
                  ${item.endCityName}`"
                  :value="item.lineId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>车辆信息
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="车牌号码" prop="carNumber">
              <custom-car-number v-model="form.carNumber"></custom-car-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌类型" prop="carNumberType">
              <el-select
                style="width: 100%"
                v-model="form.carNumberType"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('car_number_type')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车辆使用性质" prop="vehicleUseType">
              <el-select
                style="width: 100%"
                v-model="form.vehicleUseType"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('vehicle_function')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车型" prop="vehicleMode">
              <el-select
                style="width: 100%"
                v-model="form.vehicleMode"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('vehicle_mode')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体积" prop="volume">
              <el-input
                v-model="form.volume"
                clearable
                type="number"
                autocomplete="off"
                placeholder="请输入"
              ><template slot="append">方</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车长" prop="vehicleLength">
              <el-select
                style="width: 100%"
                v-model="form.vehicleLength"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('vehicle_length')"
                  :key="item.dictLabel"
                  :label="item.dictLabel + '米'"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="承重" prop="loadBearing">
              <el-input
                v-model="form.loadBearing"
                clearable
                type="number"
                autocomplete="off"
                placeholder="请输入"
                ><template slot="append">吨</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车宽" prop="vehicleWidth">
              <el-input
                v-model="form.vehicleWidth"
                clearable
                type="number"
                autocomplete="off"
                placeholder="请输入"
              ><template slot="append">米</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车高" prop="vehicleHeight">
              <el-input
                v-model="form.vehicleHeight"
                clearable
                type="number"
                autocomplete="off"
                placeholder="请输入"
              ><template slot="append">米</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开门方式" prop="openMethod">
              <el-select
                style="width: 100%"
                v-model="form.openMethod"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('open_method')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否有尾板" prop="tailBoard">
              <el-radio-group v-model="form.tailBoard">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <div class="right-title">-->
<!--          <el-image :src="cheImage" class="title-label"></el-image>三证材料-->
<!--        </div>-->
<!--        <el-row :gutter="20">-->
<!--          <div class="photo-box">-->
<!--            <div class="photo-list">-->
<!--              <el-form-item prop="vehicleLicenceId" label="行驶证">-->
<!--                &lt;!&ndash;                <div class="photo-title">行驶证</div>&ndash;&gt;-->
<!--                <upload-files1 v-model="form.vehicleLicenceId"></upload-files1>-->
<!--              </el-form-item>-->
<!--            </div>-->

<!--            <div class="photo-list">-->
<!--              <el-form-item prop="drivingLicenceId" label="驾驶证">-->
<!--                &lt;!&ndash;                <div class="photo-title">驾驶证</div>&ndash;&gt;-->
<!--                <upload-files1 v-model="form.drivingLicenceId"></upload-files1>-->
<!--              </el-form-item>-->
<!--            </div>-->

<!--            <div class="photo-list">-->
<!--              <el-form-item prop="idCardId" label="身份证">-->
<!--                &lt;!&ndash;                <div class="photo-title">身份证</div>&ndash;&gt;-->
<!--                <upload-files1 v-model="form.idCardId"></upload-files1>-->
<!--              </el-form-item>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-row>-->
      </el-form>
    </div>
  </DrawerContainer>
</template>

<script>
import DrawerContainer from "@/components/Drawer.vue";
import CustomCarNumber from "@/components/CustomCarNumber.vue";
import { validatePhone, validatePrice } from "@/utils/validate";
import { getSelectCompany } from "@/views/SystemManagement/CompanyManagement/api";
import { getAreaNext, getCheDuiZhang, getDispatchers } from "@/views/commonApi";
import { getConfig } from "@/utils/localDict";
import { getBaseLine } from "@/views/ServiceConfig/CarrierRouteConfig/api";
import uploadFiles4 from "@/components/UploadFiles4.vue";
import UploadFiles1 from "@/components/UploadFiles1.vue";
import { detailInfo } from "./api";
import { editDriverInfo, saveDriverInfo } from "./api";
import { setAreaTree } from "@/utils";
export default {
  name: "AddOrEdit",
  components: {
    UploadFiles1,
    DrawerContainer,
    uploadFiles4,
    CustomCarNumber,
  },
  data() {
    return {
      dialogTitle: "新增临调司机",
      dialogShow: false,
      cheImage: require("@/assets/imgs/title.png"),
      // cityProps: {
      //   lazy: true,
      //   checkStrictly: true, //可选择任意节点
      //   lazyLoad(node, resolve) {
      //     // setTimeout(() => {
      //     const nodes = [];
      //     let query = {};
      //     // 构造查询条件
      //     if (node.value) {
      //       query = {
      //         code: node.value,
      //       };
      //     }
      //     //查询接口
      //     getAreaNext(query).then((res) => {
      //       res.data.map((item) => {
      //         let obj = {
      //           value: item.areaCode,
      //           label: item.areaName,
      //           leaf: item.areaLevel === 2,
      //           disabled: item.areaLevel <= 1,
      //         };
      //         nodes.push(obj);
      //       });
      //       //重新加载节点
      //       resolve(nodes);
      //     });
      //     // }, 500);
      //   },
      // },
      cityProps: {
        value: "areaCode",
        label: "areaName",
        checkStrictly: true,
      },
      form: {
        addressDot: [],
        carNumber: "",
        carNumberType: "",
        cityCode: "",
        cityName: "",
        driverId: "",
        companyId: "",
        districtCode: "",
        districtName: "",
        drivingLicenceId: "",
        gpsId: "",
        idCardId: "",
        lineId: "",
        lineType: 1,
        loadBearing: "",
        openMethod: "",
        phone: "",
        provinceCode: "",
        provinceName: "",
        username: "",
        vehicleLength: "",
        vehicleLicenceId: "",
        vehicleMode: "",
        vehicleUseType: "",
        volume: "",
      },
      rules: {
        username: [{ required: true, message: "司机姓名不能为空" }],
        lineType: [{ required: true, message: "线路类型不能为空" }],
        phone: [
          { required: true, message: "联系方式不能为空" },
          { validator: validatePhone, trigger: "blur" },
        ],
        carNumber: [{ required: true, message: "车牌号不能为空" }],
        companyId: [{ required: true, message: "所属机构不能为空" }],
        vehicleLeaderId: [{ required: true, message: "车队长不能为空" }],
        addressDot: [{ required: true, message: "常驻地址不能为空" }],
        volume: [{ required: true, message: "体积不能为空" }],
        loadBearing: [{ required: true, message: "承重不能为空" }],
        vehicleLength: [{ required: true, message: "车长不能为空" }],
        vehicleMode: [{ required: true, message: "车型不能为空" }],
        vehicleLicenceId: [{ required: true, message: "上传行驶证" }],
        idCardId: [{ required: true, message: "身份证驶证" }],
        drivingLicenceId: [{ required: true, message: "驾驶证行驶证" }],
        managementFee: [
          { required: true, message: "管理费不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        premium: [
          { required: true, message: "保险费不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        gpsFee: [
          { required: true, message: "GPS费不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        onlineFee: [
          { required: true, message: "上线费用不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        carNumberType: [{ required: true, message: "车牌类型不能为空" }],
        vehicleUseType: [{ required: true, message: "车辆使用性质不能为空" }],
        lineId: [{ required: true, message: "线路不能为空" }],
      },
      companyList: [], // 公司
      vehicleLeaderData: [], // 车队长
      lineData: [], // 线路
      vehicleModel: ["黄牌", "绿牌"], // 车型枚举
      loading: false, // loading
      userInfo: JSON.parse(localStorage.getItem("u")),
    };
  },
  watch: {
    "form.companyId": function (val) {
      if (val) {
        // this.getLineData(val);
        this.getCheDuiZhang(val);
      } else {
        this.lineId = "";
        this.vehicleLeaderId = "";
        this.lineData = [];
        this.vehicleLeaderData = [];
      }
    },
  },
  computed: {
    options: function() {
      let treeData = JSON.parse(localStorage.getItem("area")) || []
      return setAreaTree(treeData, 2)
    }
  },
  mounted() {},
  methods: {
    getConfig,
    resetDrawer() {
      this.dialogShow = false;
      this.form = this.$options.data().form;
      if (this.$refs.form) this.$refs.form.resetFields();
    },
    // 获取公司
    getSelectCompany() {
      getSelectCompany().then((res) => {
        if (res.code === 200) {
          this.companyList = res.data;
        }
      });
    },
    // 获取公司下线路
    getLineData(val) {
      getBaseLine(val).then((res) => {
        if (res.code === 200) {
          this.lineData = res.data;
        }
      });
    },
    // 获取公司下车队长
    getCheDuiZhang(val) {
      getCheDuiZhang(val).then((res) => {
        if (res.code === 200) {
          this.vehicleLeaderData = res.data;
        }
      });
    },
    getDetail(driverId) {
      detailInfo(driverId).then((res) => {
        if (res.code === 200) {
          let arr = [
            res.data.provinceCode,
            res.data.cityCode,
            res.data.districtCode,
          ];
          this.$set(this.form, "addressDot", arr);
          this.form.driverId = res.data.driverId;
          this.form.carNumber = res.data.carNumber;
          this.form.companyId = res.data.companyId;
          this.form.drivingLicenceId = res.data.drivingLicenceId;
          this.form.idCardId = res.data.idCardId;
          this.form.lineId = res.data.lineId;
          this.form.lineType = res.data.lineType;
          this.form.loadBearing = res.data.loadBearing;
          this.form.phone = res.data.phone;
          this.form.carNumberType = res.data.carNumberType;
          this.form.username = res.data.username;
          this.form.vehicleLength = res.data.vehicleLength;
          this.form.vehicleLicenceId = res.data.vehicleLicenceId;
          this.form.vehicleMode = res.data.vehicleMode;
          this.form.volume = res.data.volume;
          this.form.vehicleUseType = res.data.vehicleUseType;
          this.form.provinceCode = res.data.provinceCode;
          this.form.provinceName = res.data.provinceName;
          this.form.districtName = res.data.districtName;
          this.form.districtCode = res.data.districtCode;
          this.form.cityCode = res.data.cityCode;
          this.form.openMethod = res.data.openMethod;
          this.form.cityName = res.data.cityName;

          // this.$set(this.form, "addressDot", arr);
          // ;
          // // // console.log("this.form.addressDot", this.form.addressDot);
          this.$forceUpdate();
        }
      });
    },
    init(row) {
      this.getSelectCompany();
      this.getLineData()
      if (!!row) {
        this.getDetail(row.driverId);
        this.dialogTile = "编辑临调司机"
      } else {
        this.form.companyId = this.userInfo.companyId;
        this.dialogTile = "新增临调司机"
      }

      this.dialogShow = true;
    },
    handleChangeAddress() {
      // 可以通过 this.$refs.cascader.getCheckedNodes() 获取选中的节点信息
      this.form.provinceCode = "";
      this.form.provinceName = "";
      this.form.cityCode = "";
      this.form.cityName = "";
      this.form.districtCode = "";
      this.form.districtName = "";
      const nodes = this.$refs.cascaderEnd.getCheckedNodes();
      nodes[0].pathNodes.forEach((node, index) => {
        if (index === 0) {
          this.form.provinceCode = node.value;
          this.form.provinceName = node.label;
        } else if (index === 1) {
          this.form.cityCode = node.value;
          this.form.cityName = node.label;
        } else if (index === 2) {
          this.form.districtCode = node.value;
          this.form.districtName = node.label;
        }
      });
      // // console.log("选中的名称end:", this.end);
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.drawerContainer.loading = true;
          let methodName = "";
          if (this.form.driverId) {
            methodName = editDriverInfo;
          } else {
            methodName = saveDriverInfo;
          }
          methodName(this.form)
            .then((res) => {
              this.$refs.drawerContainer.loading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.driverId ? "编辑成功" : "保存成功"
                );
                this.dialogShow = false;
                this.$emit("success");
              }
            })
            .catch((e) => {
              this.$refs.drawerContainer.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.driver-box {
  box-sizing: border-box;
  .right-title {
    padding: 0rem 0 0.2rem;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .photo-box {
    display: flex;
    .photo-list {
      margin-left: 0.2rem;
      .photo-title {
        color: #8c8c8c;
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding-bottom: 0.1rem;
      }
    }
  }
}
</style>
